import React from 'react';

interface AiOrbProps {
  size?: number;
  pulse?: boolean;
  className?: string;
}

export function AiOrb({ size = 26, pulse = true, className = '' }: AiOrbProps) {
  return (
    <div className={`relative flex-shrink-0 ${className}`} style={{ width: size, height: size }}>
      <div
        className="w-full h-full rounded-full flex items-center justify-center ai-orb"
        style={{ background: 'linear-gradient(135deg, #8F6BFF 0%, #4A63E8 100%)' }}
      >
        <span style={{ fontSize: size * 0.42, color: 'white' }}>✦</span>
      </div>
      {pulse && (
        <div
          className="absolute rounded-full border-2 pulse-ring"
          style={{
            inset: -3,
            borderColor: '#159662',
          }}
        />
      )}
    </div>
  );
}
